import _definePage_default_0 from '/app/src/pages/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/app/src/pages/apps/chat-matrix-fast.vue?definePage&vue'

export const routes = [
  {
    path: '/',
    name: 'root',
    component: () => import('/app/src/pages/index.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/app/src/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  {
    path: '/apps',
    /* internal name: 'apps' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'chat-matrix-fast',
        name: 'apps-chat-matrix-fast',
        component: () => import('/app/src/pages/apps/chat-matrix-fast.vue'),
        /* no children */
      },
  _definePage_default_2
  )
    ],
  },
  {
    path: '/LandingPage',
    name: 'landing-page',
    component: () => import('/app/src/pages/LandingPage.vue'),
    /* no children */
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('/app/src/pages/login.vue'),
    /* no children */
  },
  {
    path: '/logto-callback',
    name: 'logto-callback',
    component: () => import('/app/src/pages/logto-callback.vue'),
    /* no children */
  },
  {
    path: '/matrix-callback',
    name: 'matrix-callback',
    component: () => import('/app/src/pages/matrix-callback.vue'),
    /* no children */
  },
  {
    path: '/second-page',
    name: 'second-page',
    component: () => import('/app/src/pages/second-page.vue'),
    /* no children */
  }
]
